
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/button-base",
      function () {
        return require("private-next-pages/material-ui/api/button-base.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/button-base"])
      });
    }
  